import classNames from 'classnames/bind';
import React from 'react';

import Header from './01_Header';
import Lists from './02_Lists';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const MissionInfo = () => {
  return (
    <div className={cx('container')}>
      <Header />
      <Lists />
    </div>
  );
};

export default MissionInfo;
